import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import baseUrl from "../../baseUrl";
import EmptyData from "../../Components/EmptyData/EmptyData";
import HomeShowcaseCard from "../../Components/HomeShowcaseCard/HomeShowcaseCard";
import Spinner from "../../Components/Spinner/Spinner";

const BlogByUser = () => {
  const [blogs, setBlogs] = useState([]);
  const [fullName, setFullName] = useState("");
  const [loading, setLoading] = useState(false);
  const { id } = useParams();
  useEffect(() => {
    setLoading(true);
    axios
      .post(`${baseUrl}/blog/blog-by-user`, { userId: id })
      .then((response) => {
        console.log(response.data);
        if (response.data.success === true) {
          setBlogs(response.data.blogs);
          setFullName(response.data.fullName);
        } else {
          toast.error(response.data.message);
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [id]);

  return (
    <>
      {loading && <Spinner />}
      {blogs.length <= 0 ? (
        <EmptyData message={"Oops! No trending blogs."} />
      ) : (
        <section className="text-gray-600 body-font">
          <div className="container px-5 py-5 mx-auto">
            <div className="flex">
              <h1 className="text-2xl font-bold p-4">
                Blog from{" "}
                <Link className="text-indigo-700 " to={`/other-user/${id}`}>
                  {fullName}
                </Link>
              </h1>
            </div>
            <div className="flex flex-wrap -m-4">
              {blogs.map((blog) => (
                <HomeShowcaseCard key={blog._id} blog={blog} />
              ))}
            </div>
          </div>
        </section>
      )}
    </>
  );
};

export default BlogByUser;
